export default "__VITE_ASSET__342e4d24__"